import axios from 'axios'
const api  = axios

const store = {
    actions : {
        getServiceByid : async ({}, data:any) => {
            try{
                return await api.get('Travel/', {params:data})
            }catch(error){
                return error.response
            }
        },
        getAllLocations : async ({}) => {
            try{
                const response = await api.get('Travel/locations')
                if(response.status === 200) return response
            }catch(error){
                return error.response
            }
        },
        getAllServices : async({}, state) => {
            try{
                const response = await api.get('/Travel/bystatus/'+state)
                if(response.status == 200){
                    return response
                }
            }catch(error){
                return error.response
            }
        },
        deleteService : async({}, serviceId) => {
            try{
                const response = await api.delete('/Travel/'+serviceId)
                if(response.status === 200){
                    return response
                }
            }catch(eror){
                return eror.response
            }
        },
        getAllServiceTypes : async({}, state) => {
            try{
                const response = await api.get('/Travel/serviceType/')
                if(response.status == 200){
                    return response
                }
            }catch(error){
                return error.response
            }
        },
        getPdf: async({}, url:string) => {
            try{
                const response = await api.get(url,{
                    responseType: 'arraybuffer'})
                if(response.status == 200){
                    return response
                }
            }catch(error){
                return error.response
            }
        },
        createNewService: async({}, data:any)=>{
            try{
                const response = await api.post('/Travel',data)
                return response
            }catch(error ){
                return error.response
            }
        },
        createNewFormContact: async({}, data:any)=>{
            try{
                const response = await api.post('/Travel/request',data)
                return response
            }catch(error ){
                return error.response
            }
        },
        getAllRequest : async ( {}, status) => {
            return await api.get('/Travel/request/'+status)
        },
        markAsFinish: async({},data)=> {
            return await api.post('/Travel/request/markAsFinish', data)
        },
        payWorker : async ({}, data:any) => {
            return await api.put('Travel/travelWorker/markAsPaid',data)
        },
        updateService : async({}, data:any) => {
            try{
                return await api.put('/Travel',data)
            }catch(error){
                return error.response
            }
        },
        getCurrentDate : async ( {}) => {
            return await api.get('/Travel/currentDate')
        },
        toDo: async ({})=> {
            try{
                const response = await api.get('/Travel/kanban/ToDo')
                return response
            }catch(error) {
                return error.response
            }
        },
        doing: async ({})=> {
            try{
                return await api.get('/Travel/kanban/doing')
            }catch(error){
                return error.response
            }
        },
        moveTicket : async ({},data) => {
            return await api.put('/Travel/kanban/moveTicket/'+data.idTravel+'/travelWorker/'+data.idTravelWorker)
        },

        finishTask : async ({},data ) => {
                return await api.post('/Travel/kanban/finish', data, {     
                    headers:
                    {
                        'Content-Type': 'multipart/form-data',
                    }                           
                })
        },
        updateDetail : async ({},data ) => {
            return await api.put('/Travel/detail', data)
        },
        cancelService : async ({},idTravel)=>{
            return await api.put('/Travel/cancel/'+idTravel)
        }
    }
}

export default store